<template>
  <v-layout column justify-center align-center class="mt-4 pt-2">
    <VueCompareImage
      class="hidden-md-and-down"
      hover
      :style="{ minWidth: '1300px' }"
      :sliderLineWidth="sliderLine"
      :handleSize="hSize"
      :leftImage="leftImage"
      :rightImage="rightImage"
      :sliderPositionPercentage="sliderPosition"
    />
    <VueCompareImage
      class="hidden-lg-and-up"
      hover
      :style="{ maxWidth: '400px' }"
      :sliderLineWidth="sliderLine"
      :handleSize="hSize"
      :leftImage="leftImage2"
      :rightImage="rightImage2"
      :sliderPositionPercentage="sliderPosition"
    />

    <br>

    <vue-typer class="headline" :repeat="0" text="Luis Silva"></vue-typer>
    <vue-typer
      :text="text1"
      :repeat="Infinity"
      :shuffle="false"
      initial-action="erasing"
      :pre-type-delay="70"
      :type-delay="70"
      :pre-erase-delay="1980"
      :erase-delay="150"
      erase-style="select-back"
      :erase-on-complete="false"
      caret-animation="smooth"
    ></vue-typer>
    <br>
    <v-btn v-show="false" color="blue" dark large class="mb-3" @click="openIntroVideo">
      View Me
      <v-icon right dark>fas fa-play-circle</v-icon>
    </v-btn>
    <v-flex xs12 sm8 md7 lg6 xl6>
      <v-card flat color="transparent" max-width="560" style="text-align: justify">
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">
              <span>Build it the</span>
              <span class="blue--text"> Silva's Way</span>
            </h3>
            <div>
              <br>
              <p>
                Welcome. Whether you are visiting for the first time or already working with me, you are in the right place.
                <br><br>
                <span v-show="false">
                At <span class="blue--text font-weight-bold">Silva's SCS</span> I design and deliver custom web software as a nearshore partner — C#, ASP.NET Core, PHP, REST APIs, and modern JavaScript frameworks — with over <b>{{ new Date().getFullYear() - 2015 }} years</b> in the field.
                </span>
                I am a software engineer who uses AI for <b>debugging, documentation, and researching</b>. AI is not accountable — I am. That is where my experience brings value: I own the delivered results. I test from point A to point B to make sure the work aligns with the business. Most of the time, AI does not know what is best for the business. That is why I am there.
                <br><br>
                My focus is simple: <b>happy clients, software that adds real value, and systems you can run the business on</b>.
                <span v-show="false">
                <br><br>
                Watch a short intro, then explore my career and services. I would be glad to help you ship what comes next.
                <br><br>
                Thank you for choosing <span class="blue--text font-weight-bold">Silva's SCS</span>.
                </span>
                <br><br>
                So, if you're looking for a reliable developer for a Proof of Concept (PoC) or a long-term engagement, just click my profile. Let's talk and turn your ideas into reality.
              </p>
            </div>
          </div>
        </v-card-title>

        <v-card-actions class="hidden-sm-and-down">
          <v-btn
            v-for="icon in socialIcons"
            :key="icon.icon"
            fab
            dark
            outline
            color="blue"
            :href="icon.href"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-icon dark>{{icon.icon}}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-card-actions class="hidden-md-and-up justify-left">
          <v-btn
            v-for="icon in socialIcons"
            :key="icon.icon"
            small
            fab
            dark
            outline
            color="blue"
            :href="icon.href"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-icon dark>{{icon.icon}}</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-dialog v-model="videoDialog" max-width="800" lazy>
      <v-card>
        <v-card-title class="headline">
          <span>Meet</span>
          <span class="blue--text">&nbsp;Luis Silva</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeIntroVideo">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <div class="intro-video-wrap">
          <iframe
            v-if="videoDialog"
            :src="introVideoSrc"
            title="Luis Silva intro video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { VueTyper } from "vue-typer";
import VueCompareImage from "vue-compare-image";

export default {
  metaInfo: {
    title: "Home",
    titleTemplate: "%s ← Independent Contractor | Silva's SCS",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "description", content: "Luis Silva is an independent incorporated contractor and the sole employee of Silva's SCS. One-person software engineering company using AI for debugging, documentation, and research — with the contractor accountable for delivered results." },
      { charset: "utf-8" },
      { property: "og:title", content: "Independent Contractor | Silva's SCS" },
      { property: "og:site_name", content: "Independent Contractor | Silva's SCS" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://silvassoftwareconsultingservices.com" },
      {
        property: "og:image",
        content: "/favicon_io/apple-touch-icon.png"
      },
      { property: "og:description", content: "Luis Silva is an independent incorporated contractor and the sole employee of Silva's SCS, a one-person software engineering company." }
    ]
  },
  components: {
    "vue-typer": VueTyper,
    VueCompareImage
  },
  data() {
    return {
      videoDialog: false,
      introVideoId: "W8TqqKEZ25o",
      icons: [
      {  },
      {  },
      {  },
        { href: "https://github.com/LuisSilva2014", icon: "fab fa-github" },
        {
          href: "https://www.linkedin.com/in/luis-silva-spm",
          icon: "fab fa-linkedin-in"
        },
        {  },
        {  },
        {  },
      ],
      text1: ["Senior FullStack Web Developer", "Independent Incorporated Contractor", "Your partner and ally in web development"],
      leftImage: "/sscs_slide_1.jpg",
      rightImage:  "/sscs_slide_2.jpg",
      leftImage2: "/sscs_portrait1.jpeg",
      rightImage2: "/sscs_portrait2.jpeg",
      sliderLine: 0,
      hSize: 0,
      sliderPosition: 0.69
    };
  },
  computed: {
    socialIcons() {
      return this.icons.filter(function (icon) {
        return icon && icon.href && icon.icon;
      });
    },
    introVideoSrc() {
      return "https://www.youtube.com/embed/" + this.introVideoId + "?autoplay=1&rel=0";
    }
  },
  methods: {
    openIntroVideo() {
      this.videoDialog = true;
    },
    closeIntroVideo() {
      this.videoDialog = false;
    }
  }
};
</script>
<style>
@keyframes rocking {
  0%,
  100% {
    transform: rotateZ(-10deg);
  }

  50% {
    transform: rotateZ(10deg);
  }
}

.vue-typer {
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}
.vue-typer .custom.char.typed {
  color: #609cd2;
}
.vue-typer .custom.char.selected {
  color: #e91e63;
}

.vue-typer .custom.caret {
  animation: rocking 1s ease-in-out 0s infinite;
}
.vue-typer .custom.caret.typing {
  background-color: #609cd2;
}
.vue-typer .custom.caret.selecting {
  display: inline-block;
  background-color: #e91e63;
}

.intro-video-wrap {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  background: #000;
}

.intro-video-wrap iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>

